exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rounded-number{font-family:Courier, sans-serif}\n", ""]);
